import type { ExamTypeConfig } from '@examflow/core';
import { registerExamQuestionTypes } from '@examflow/core';
import { SIELE_SECTIONS } from './sections';
import { sieleScoringRules } from './scoring';
import { SIELE_QUESTION_TYPE_DEFINITIONS } from './questionTypes';

/**
 * SIELE 考试完整配置
 */
export const sieleExamConfig: ExamTypeConfig = {
  id: 'siele',
  name: 'SIELE (Servicio Internacional de Evaluación de la Lengua Española)',
  description: 'SIELE 是国际西班牙语评估服务，提供在线西班牙语能力认证',
  languageId: 'spanish',
  questionTypeDefinitions: SIELE_QUESTION_TYPE_DEFINITIONS,
  sections: SIELE_SECTIONS,
  scoringRules: sieleScoringRules,
};

registerExamQuestionTypes('siele', Object.values(SIELE_QUESTION_TYPE_DEFINITIONS));

export * from './types';
export * from './levels';
export * from './sections';
export * from './scoring';
export * from './intro';
export * from './questionTypes';
